import request from '@/utils/request'

// @deprecated 未被外部引用
export interface LoginParams {
  username: string
  password: string
}

export interface LoginWithCaptchaParams {
  username: string
  password: string
  captchaKey?: string
  captchaCode?: string
}

export interface RoleInfo {
  code: string
  name: string
  nameEn?: string
}

export interface LoginResult {
  token: string
  tokenType: string
  expiresIn: number
  user: {
    id: number
    username: string
    realName: string
    email: string
    phone: string
    preferredLanguage?: string
    roles: RoleInfo[]
    department?: string
  }
  permissions: string[]
  mustChangePassword?: boolean
}

export const login = (username: string, password: string): Promise<LoginResult> => {
  return request.post('/api/auth/login', { username, password })
}

export const loginWithCaptcha = (params: LoginWithCaptchaParams): Promise<LoginResult> => {
  return request.post('/api/auth/login', params)
}

// @deprecated 未被外部引用
export interface CurrentUserInfo {
  id: number
  username: string
  realName: string
  email: string
  phone: string
  role?: string
  roles: RoleInfo[]
  department?: string
  permissions?: string[]
}

export const getCurrentUser = (): Promise<CurrentUserInfo> => {
  return request.get('/api/auth/me')
}

export const changePassword = (oldPassword: string, newPassword: string): Promise<void> => {
  return request.post('/api/auth/change-password', { oldPassword, newPassword })
}
